import type { Dispatch } from 'react';
import { useCallback, useState } from 'react';
import { ButtonMain } from '@quero-delivery/quero-components-web';
import { Table } from 'semantic-ui-react';
import { Modal } from '@querodelivery/uni-react';
import styles from './styles.module.scss';
import { ModalSetStatusOfflineDeliveryman } from '../modal-change-status-deliveryman';
import { DeliverymanRowTable } from './components/deliveryman-row-table';
import type { OnlineDeliveryman } from '@/_features/dashboard/types';
import { MODAL_WIDTH } from '@/_constants/styles';

interface ModalListActiveDeliverymenProps {
  open: boolean;
  onClose: Dispatch<ModalListActiveDeliverymenProps['open']>;
  onlineDeliverymen: OnlineDeliveryman[];
}

function ModalListActiveDeliverymen({
  open,
  onClose,
  onlineDeliverymen,
}: ModalListActiveDeliverymenProps) {
  const [offlineIdsDeliverymen, setOfflineIdsDeliverymen] = useState<string[]>(
    [],
  );

  const [openModalChangeDeliveryman, setOpenModalChangeDeliveryman] =
    useState(false);

  function handleClose() {
    onClose(false);
    setOfflineIdsDeliverymen([]);
  }

  const getIsDeliverymanSelected = useCallback(
    (motoboyId: string) => {
      return offlineIdsDeliverymen.includes(motoboyId);
    },
    [offlineIdsDeliverymen],
  );

  const onSelectedChange = useCallback(
    (motoboyId: string, IsSelected: boolean) => {
      if (IsSelected) {
        setOfflineIdsDeliverymen(prevValues =>
          prevValues.filter(item => item !== motoboyId),
        );
      } else {
        setOfflineIdsDeliverymen((prevValues: string[]) => [
          ...prevValues,
          motoboyId,
        ]);
      }
    },
    [offlineIdsDeliverymen],
  );

  return (
    <Modal
      isOpen={open}
      onClose={handleClose}
      width={MODAL_WIDTH.lg}
      className={styles.modal}
      header="Entregadores ativos"
    >
      <span>
        {onlineDeliverymen.length}{' '}
        {onlineDeliverymen.length > 1
          ? 'Entregadores ativos:'
          : 'Entregador ativo:'}
      </span>
      <div className={styles.containerTable}>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Nome:</Table.HeaderCell>
              <Table.HeaderCell>Status:</Table.HeaderCell>
              <Table.HeaderCell>Última entrega:</Table.HeaderCell>
              <Table.HeaderCell>Mudar status:</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {onlineDeliverymen.map(deliveryman => (
              <DeliverymanRowTable
                deliveryman={deliveryman}
                isSelected={() => getIsDeliverymanSelected(deliveryman._id)}
                onSelectedChange={() =>
                  onSelectedChange(
                    deliveryman._id,
                    getIsDeliverymanSelected(deliveryman._id),
                  )
                }
                key={deliveryman._id}
              />
            ))}
          </Table.Body>
        </Table>
      </div>
      <div className={styles.containerButton}>
        <ButtonMain
          className={styles.buttonStyle}
          onClick={() => setOpenModalChangeDeliveryman(true)}
          disabled={!offlineIdsDeliverymen.length}
          width="40%"
        >
          Enviar mudanças
        </ButtonMain>
      </div>

      <ModalSetStatusOfflineDeliveryman
        open={openModalChangeDeliveryman}
        onClose={() => setOpenModalChangeDeliveryman(false)}
        deliverymenIds={offlineIdsDeliverymen}
        fnCallback={() => handleClose()}
      />
    </Modal>
  );
}

export { ModalListActiveDeliverymen };
